// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__LGWBq","wrapper":"error_wrapper__dn22k","title":"error_title__G747q","text":"error_text__jNyLe"};